(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flip-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  const cards = Array.from(document.querySelectorAll('.flipcard'));
  if (!cards.length) return;

  // Helper: compute numeric height of an element even if it's inside an absolute face
  function elHeight(el) { return el ? el.getBoundingClientRect().height : 0; }

  function computeFrontHeight(card) {
    const imgWrap = card.querySelector('.flipcard__front .img-wrap');
    const title   = card.querySelector('.flipcard__front .flipcard__title');
    return Math.round(elHeight(imgWrap) + elHeight(title));
  }

  // Measure collapsed band (title only) and expanded band (title + paragraph)
  function computeBandHeights(card) {
    const band   = card.querySelector('.back-band');
    const title  = band?.querySelector('.back-band__title');
    const body   = band?.querySelector('.back-band__body');

    const collapsed = Math.round(elHeight(title)); // exact title height
    // Temporarily allow the band to expand, measure full height, then restore.
    const prevMax = band.style.maxHeight;
    band.style.maxHeight = 'none';
    const expanded = Math.round(band.scrollHeight); // title + paragraph
    band.style.maxHeight = prevMax;

    return { collapsed: Math.max(collapsed, 1), expanded };
  }

  function computeBackHeight(card, expandedBandPx) {
    const imgWrap = card.querySelector('.flipcard__back .img-wrap');
    // Back grid is image row + band row; total = image fixed + band (collapsed/expanded)
    return Math.round(elHeight(imgWrap) + expandedBandPx);
  }

  function measureAndSet(card) {
    // Front total height
    const frontH = computeFrontHeight(card);

    // Band collapsed/expanded heights; write them as CSS vars so the animation uses exact values
    const { collapsed, expanded } = computeBandHeights(card);
    const band = card.querySelector('.back-band');
    if (band) {
      band.style.setProperty('--band-collapsed', collapsed + 'px');
      band.style.setProperty('--band-expanded',  expanded  + 'px');
    }

    // Back total height when fully expanded
    const backH = computeBackHeight(card, expanded);

    // Set initial height to front height
    card.style.height = frontH + 'px';
    const inner = card.querySelector('.flipcard__inner');
    if (inner) inner.style.height = frontH + 'px';

    // Store for later toggles
    card.dataset.frontH = String(frontH);
    card.dataset.backH  = String(backH);
  }

  function measureAll() { cards.forEach(measureAndSet); }

  // React to resize & load
  window.addEventListener('resize', measureAll);
  window.addEventListener('load', measureAll);
  document.addEventListener('DOMContentLoaded', measureAll);

  // Re-measure after any image loads
  const imgs = document.querySelectorAll('.flipcard img');
  imgs.forEach(img => {
    if (!img.complete) img.addEventListener('load', measureAll, { once: true });
  });

  // Hover (desktop): animate card height in sync with band expansion
  cards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      const backH = Number(card.dataset.backH || 0);
      card.style.height = backH + 'px';
      const inner = card.querySelector('.flipcard__inner');
      if (inner) inner.style.height = backH + 'px';
    });
    card.addEventListener('mouseleave', () => {
      const frontH = Number(card.dataset.frontH || 0);
      card.style.height = frontH + 'px';
      const inner = card.querySelector('.flipcard__inner');
      if (inner) inner.style.height = frontH + 'px';
    });
  });

  // Tap/keyboard flip: also toggle height
  function setHeightForState(card, flipped) {
    const h = Number(card.dataset[flipped ? 'backH' : 'frontH'] || 0);
    card.style.height = h + 'px';
    const inner = card.querySelector('.flipcard__inner');
    if (inner) inner.style.height = h + 'px';
  }

  document.addEventListener('click', (e) => {
    const card = e.target.closest('.flipcard');
    if (!card) return;
    const flipped = !card.classList.contains('is-flipped');
    card.classList.toggle('is-flipped');
    setHeightForState(card, flipped);
  });

  document.addEventListener('keydown', (e) => {
    const el = document.activeElement;
    if (!el?.classList?.contains('flipcard')) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const flipped = !el.classList.contains('is-flipped');
      el.classList.toggle('is-flipped');
      setHeightForState(el, flipped);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
